import React from "react";
import { Col } from "react-bootstrap";
import { useFormatter } from "../../util/formatter";

const MainSavingsEPC = (props) => {
	const calculateFormula = props.calculateFormula;
	const selectedSite = props.selectedSite;
	const senSavData = props.senSavData;

	const [formatNumber] = useFormatter();

	return (
		<>
			<Col md="12">
				<h5 style={{ textAlign: "center" }}>Savings</h5>
			</Col>
			<Col
				md="6"
				style={{ textAlign: "center", borderRight: "1px solid #666" }}
			>
				<h6>
					CO<sub>2</sub> Avoided
				</h6>
				<p>
					{selectedSite != null
						? formatNumber(
								calculateFormula("CO2_TREES", selectedSite, senSavData)[0]
						  )
						: ""}{" "}
					kg
				</p>
			</Col>
			<Col md="6" style={{ textAlign: "center" }}>
				<h6>Trees Planted</h6>
				<p>
					{selectedSite != null
						? formatNumber(
								calculateFormula("CO2_TREES", selectedSite, senSavData)[1]
						  )
						: ""}
				</p>
			</Col>
		</>
	);
};

export default MainSavingsEPC;
